import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-it-services',
  templateUrl: './it-services.component.html',
  styleUrls: ['./it-services.component.scss']
})
export class ItServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
